import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

interface OptionalTooltipProps extends TooltipProps {
  disabled?: boolean;
}

export const OptionalTooltip: React.FC<OptionalTooltipProps> = ({
  disabled = false,
  children,
  ...tooltipProps
}) => {
  if (disabled) {
    return <>{children}</>;
  }

  return <Tooltip {...tooltipProps}>{children}</Tooltip>;
};

export default OptionalTooltip;
